import { Button } from '@/components/shadcn-ui/button';

const PROJECT_OPTIONS = ['Kitchen Remodel', 'Bathroom Remodel', 'Room Remodel', 'Room Addition'];

export function ProjectSelector({ onSelect }) {
  return (
    <div className="flex flex-wrap justify-center gap-4 mt-6">
      {PROJECT_OPTIONS.map(option => (
        <Button
          key={option}
          variant="secondary"
          className="rounded-full px-6 py-3 text-sm font-medium bg-black text-white hover:bg-neutral-700 border-neutral-600"
          onClick={() => onSelect(option)}
        >
          {option}
        </Button>
      ))}
    </div>
  );
}
